document.addEventListener("DOMContentLoaded", () => {
  // const deferredElClicks = document.querySelectorAll('.deferred-media__poster');
  // deferredElClicks.forEach(btn => btn.click());
  // const startedVideos = new WeakSet();
  // let observer = new MutationObserver(() => {
  //   const videos = document.querySelectorAll('.deferred-media video');
  //   videos.forEach(video => {
  //     if (!startedVideos.has(video)) {
  //       try {
  //         video.click();
  //       } catch(e) {}

  //       startedVideos.add(video);
  //     }
  //   });
  // });
  // observer.observe(document.body, {
  //   childList: true,
  //   subtree: true
  // });

    // swiper slider
  document.querySelectorAll(".swiper").forEach(function(swiperEl) {
    new Swiper(swiperEl, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 20,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: swiperEl.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: swiperEl.querySelector(".swiper-button-next"),
        prevEl: swiperEl.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        576: {
            slidesPerView:2,
        },
        768: {
            slidesPerView: 3,
        },
        1024: {
          slidesPerView: 5,
        }
      }
    });
  });

  const galleryLightbox = document.querySelector(".custom-gallery");
  const lightbox = document.getElementById("lightbox");
  const lightboxImg = document.getElementById("lightbox-img");
  const btnClose = lightbox.querySelector(".lightbox-close");
  const btnPrev = lightbox.querySelector(".lightbox-prev");
  const btnNext = lightbox.querySelector(".lightbox-next");

  if (!galleryLightbox || !lightbox) return;

  if (galleryLightbox) {

    let currentIndex = 0;
    const images = Array.from(galleryLightbox.querySelectorAll("img")).map(img => img.src);

    function openLightbox(index) {
      currentIndex = index;
      lightbox.style.display = "block";
      lightboxImg.src = images[currentIndex];
    }

    function closeLightbox() {
      lightbox.style.display = "none";
    }

    function changeImage(direction) {
      currentIndex = (currentIndex + direction + images.length) % images.length;
      lightboxImg.src = images[currentIndex];
    }

    // События для картинок
    galleryLightbox.querySelectorAll("img").forEach((img, index) => {
      img.addEventListener("click", () => openLightbox(index));
    });
    // События для кнопок
    btnClose.addEventListener("click", closeLightbox);
    btnPrev.addEventListener("click", (e) => {
      e.stopPropagation();
      changeImage(-1);
    });
    btnNext.addEventListener("click", (e) => {
      e.stopPropagation();
      changeImage(1);
    });
    // Закрытие по клику на фон
    lightbox.addEventListener("click", (e) => {
      if (e.target === lightbox) closeLightbox();
    });
    // Управление клавиатурой
    document.addEventListener("keydown", (e) => {
      if (lightbox.style.display === "block") {
        if (e.key === "Escape") closeLightbox();
        if (e.key === "ArrowLeft") changeImage(-1);
        if (e.key === "ArrowRight") changeImage(1);
      }
    });
  }

});